import { ConsolidationGroupResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { getConsolidationGroupBasis } from "@components/ownership/panels/consolidationSettings.helpers";

interface ConsolidatedGlDrillDownLedger {
    ledgerId: string | undefined;
    ledgerBasis: AccountingLedgerBasis;
}

export function resolveConsolidatedGlDrillDownLedger({
    group,
    entityUuids,
}: {
    group: ConsolidationGroupResponse;
    entityUuids: string[];
}): ConsolidatedGlDrillDownLedger {
    const [entityUuid] = entityUuids;
    const ledgerId =
        entityUuids.length === 1 && entityUuid
            ? group.config?.ledgerIdsByEntityUuid?.[entityUuid]
            : undefined;
    return { ledgerId, ledgerBasis: getConsolidationGroupBasis(group) };
}
